import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import Testimonios from "../components/Testimonios";
import Footer from '../components/Footer';
import ButtonWhatsapp from '../components/ButtonWhatsapp'
import NavbarLogo from "../components/NavbarLogo";
export default function About() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const [showSpinner, setShowSpinner] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowSpinner(false);
    }, 1);

    return () => clearTimeout(timeout); // Limpieza del timeout
  }, []);
  return (
    <div>
           {showSpinner && (
        <div id="spinner"  class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
          {/* Aquí puedes personalizar el spinner */}
          <div class="spinner"></div>
        </div>
      )}
   <div className="container-fluid bg-primary px-5 d-none d-lg-block">
        <div className="row gx-0">
          <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: "45px" }}
            >
              <a
              href="https://wa.me/+541161361408?text=¡Hola!%20Quisiera%20más%20información%20sobre%20tus%20servicios%20de%20desarrollo%20web%20y%20aplicaciones."
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <small className="me-3 text-light">
                  <i
                    className="bi bi-whatsapp me-2"
                    style={{ color: "white" }}
                  ></i>
                  +54 11 6136 1408
                </small>
              </a>
              <a
                href="tel:+541161361408"
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <small className="me-3 text-light">
                  <i className="fa fa-phone-alt me-2"></i>+54 11 6136 1408
                </small>
              </a>
              <a
                href="mailto:info@elaritech.com"
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <small className="text-light">
                  <i className="fa fa-envelope-open me-2"></i>info@elaritech.com
                </small>
              </a>
            </div>
          </div>
          <div className="col-lg-4 text-center text-lg-end">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: "45px" }}
            >
              {/*    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-twitter fw-normal"></i></a> */}
              <a
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                href="https://www.facebook.com/profile.php?id=61572272330417"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f fw-normal"></i>
              </a>
              {/*                     <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-linkedin-in fw-normal"></i></a>
                    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-instagram fw-normal"></i></a>
                    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle" href=""><i className="fab fa-youtube fw-normal"></i></a> */}
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid position-relative p-0">
        <nav className="navbar navbar-expand-lg navbar-dark px-5 py-3 py-lg-0">
          <NavbarLogo />
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="fa fa-bars"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0">
              <Link to="/" className="nav-item nav-link ">
                Inicio
              </Link>
              <Link to="/sobre-nosotros" className="nav-item nav-link active">
                Sobre Nosotros
              </Link>
              <Link to="/nuestros-servicios" className="nav-item nav-link">
                Servicios
              </Link>

              <Link to="/contáctanos" className="nav-item nav-link">
                Contáctanos
              </Link>
            </div>
            <Link
                      to="/cotización"
                      class="btn btn-primary py-2 px-4 ms-3"
                    >
                      Solicitar Cotización
                    </Link>
          </div>
        </nav>

        <div
          class="container-fluid bg-primary py-5 bg-header"
          style={{ marginBottom: "90px" }}
        >
          <div class="row py-5">
            <div class="col-12 pt-lg-5 mt-lg-5 text-center">
              <h1 class="display-4 text-white animated zoomIn">
                Sobre Nosotros
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="searchModal" tabindex="-1">
        <div class="modal-dialog modal-fullscreen">
          <div
            class="modal-content"
            style={{ background: "rgba(9, 30, 62, .7)" }}
          >
            <div class="modal-header border-0">
              <button
                type="button"
                class="btn bg-white btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body d-flex align-items-center justify-content-center">
              <div class="input-group" style={{ maxWidth: "600px" }}>
                <input
                  type="text"
                  class="form-control bg-transparent border-primary p-3"
                  placeholder="Type search keyword"
                />
                <button class="btn btn-primary px-4">
                  <i class="bi bi-search"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid  wow fadeInUp" data-wow-delay="0.1s">
        <div className="container ">
          <div className="row g-5">
            <div className="col-lg-7">
              <div className="section-title position-relative pb-3 mb-5">
                <h5 className="fw-bold text-primary text-uppercase">
                  Sobre Nosotros
                </h5>
                <h2 className="h1 mb-0">
                  La Mejor Solución IT con Más de 3 Años de Experiencia
                </h2>
              </div>
              <p className="mb-4">
                En ELARITECH, contamos con más de 3 años de experiencia
                brindando soluciones innovadoras en desarrollo web, móvil y de
                televisión. Durante este tiempo, hemos trabajado con una amplia
                variedad de clientes, ayudándolos a transformar sus ideas en
                productos digitales exitosos. Nos apasiona crear soluciones
                personalizadas que se adapten a las necesidades específicas de
                cada uno de nuestros clientes.
              </p>
              <div className="row g-0 mb-3">
                <div className="col-sm-6 wow zoomIn" data-wow-delay="0.2s">
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>Soluciones
                    Personalizadas
                  </h5>
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>Equipo
                    Profesional
                  </h5>
                </div>
                <div className="col-sm-6 wow zoomIn" data-wow-delay="0.4s">
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>Soporte
                    24/7
                  </h5>
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>Compromiso
                    con la Calidad
                  </h5>
                </div>
              </div>

              <div
                className="d-flex align-items-center mb-4 wow fadeIn"
                data-wow-delay="0.6s"
              >
                <div
                  className="bg-primary d-flex align-items-center justify-content-center rounded"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="fa fa-phone-alt text-white"></i>
                </div>
                <div className="ps-4">
                  <h5 className="mb-2">Llámanos para cualquier pregunta</h5>
                  <h4 className="text-primary mb-0">+54 11 6136 1408</h4>
                </div>
              </div>
              <Link
                to="/cotización"
                className="btn btn-primary py-3 px-5 mt-3 wow zoomIn"
                data-wow-delay="0.9s"
              >
                Solicitar Cotización
              </Link>
            </div>
            <div className="col-lg-5" style={{ minHeight: "500px" }}>
              <div className="position-relative h-100">
                <img
                  className="position-absolute w-100 h-100 rounded wow zoomIn"
                  data-wow-delay="0.9s"
                  src={require("../img/nosotros1.webp")}
                  alt="Trabajo colaborativo en desarrollo de software"
                  loading="lazy"
                  decoding="async"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid  wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div
            className="section-title text-center position-relative pb-3 mb-5 mx-auto"
            style={{ maxWidth: "600px" }}
          >
            <h5 className="fw-bold text-primary text-uppercase">
              ¿Por Qué Elegirnos?
            </h5>
            <h2 className="h1 mb-0">
              Estamos Aquí Para Hacer Crecer Tu Negocio Exponencialmente
            </h2>
          </div>
          <div className="row g-5">
            <div className="col-lg-4">
              <div className="row g-5">
                <div className="col-12 wow zoomIn" data-wow-delay="0.2s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fa fa-cubes text-white"></i>
                  </div>
                  <h4>Los Mejores en la Industria</h4>
                  <p className="mb-0">
                    Nos especializamos en crear soluciones innovadoras y
                    personalizadas para empresas de todos los tamaños.
                  </p>
                </div>
                <div className="col-12 wow zoomIn" data-wow-delay="0.6s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fa fa-users-cog text-white"></i>
                  </div>
                  <h4>Equipo de Expertos</h4>
                  <p className="mb-0">
                    Nuestro equipo de profesionales es altamente calificado y
                    experimentado en el desarrollo de soluciones tecnológicas de
                    vanguardia en web, móvil y TV.
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 wow zoomIn"
              data-wow-delay="0.9s"
              style={{ minHeight: "350px" }}
            >
              <div className="position-relative h-100">
                <img
                  className="position-absolute w-100 h-100 rounded wow zoomIn"
                  data-wow-delay="0.1s"
                  src={require("../img/nosotros2.webp")}
                  alt="Planificación de soluciones digitales para negocios"
                  loading="lazy"
                  decoding="async"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="row g-5">
                <div className="col-12 wow zoomIn" data-wow-delay="0.4s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fa fa-check-circle text-white"></i>
                  </div>
                  <h4>Historial Comprobado</h4>
                  <p className="mb-0">
                    Con más de 3 años de experiencia, hemos ayudado a empresas a
                    escalar y prosperar mediante soluciones tecnológicas
                    innovadoras.
                  </p>
                </div>
                <div className="col-12 wow zoomIn" data-wow-delay="0.8s">
                  <div
                    className="bg-primary rounded d-flex align-items-center justify-content-center mb-3"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="fa fa-phone-alt text-white"></i>
                  </div>
                  <h4>Soporte 24/7</h4>
                  <p className="mb-0">
                    Ofrecemos soporte continuo para asegurar que tu negocio
                    funcione sin interrupciones en todo momento.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

     {/*  <Testimonios /> */}

   <Footer/>
<ButtonWhatsapp/>
    </div>
  );
}
